import Modules from '@app/modules';
import CompanyStore from '@app/modules/RF/Company/store';
Modules.register({
    namespace: 'RF/Company',
    store: CompanyStore,
    blocks: {
        team: function () { return import(/* webpackChunkName: "Blocks-TeamList" */ '@app/modules/RF/Company/Blocks/team.vue'); },
        jobs: function () { return import(/* webpackChunkName: "Blocks-JobList" */ '@app/modules/RF/Company/Blocks/jobs.vue'); },
    }
});
